import { HttpContextToken } from '@angular/common/http';

export const IS_AUTHENTICATED = new HttpContextToken<boolean>(() => true);
export const SET_TENANT_DEFAULT = new HttpContextToken<boolean>(() => true);
export const SKIP_LOADING_INDICATOR = new HttpContextToken<boolean>(() => false);
// Skips the error toast and passes the error on, so the caller must handle it
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
// The API answers within 30 seconds, so anything slower is treated as hung
export const REQUEST_TIMEOUT = new HttpContextToken<number>(() => 45_000);
